const TOPICS = [
  { label: '纯爱', heat: '9.8w', desc: '甜蜜恋爱故事合集', color: 'bg-accent-100 text-accent-700' },
  { label: '奇幻', heat: '8.5w', desc: '异世界冒险篇章', color: 'bg-primary-100 text-primary-700' },
  { label: '热血', heat: '12.3w', desc: '战斗与友情羁绊', color: 'bg-accent-100 text-accent-700' },
  { label: '悬疑', heat: '7.2w', desc: '推理与反转剧情', color: 'bg-secondary-100 text-secondary-700' },
  { label: '搞笑', heat: '10.1w', desc: '轻松日常笑料不断', color: 'bg-primary-100 text-primary-700' },
  { label: '都市', heat: '8.9w', desc: '现代情感生活录', color: 'bg-secondary-100 text-secondary-700' },
  { label: '古风', heat: '6.7w', desc: '唯美古装仙侠绘卷', color: 'bg-accent-100 text-accent-700' },
  { label: '玄幻', heat: '11.4w', desc: '东方幻想大世界', color: 'bg-primary-100 text-primary-700' },
  { label: '校园', heat: '7.8w', desc: '青春校园物语', color: 'bg-secondary-100 text-secondary-700' },
  { label: '治愈', heat: '5.6w', desc: '温暖心灵的日常', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          当前最热门的漫画话题标签，点击探索你感兴趣的类型
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/80 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <span className={`inline-block px-3 py-1 rounded-full text-[12px] font-bold mb-2 ${topic.color}`}>
                {topic.label}
              </span>
              <p className="text-[13px] text-foreground-600 mb-1.5">{topic.desc}</p>
              <span className="text-[12px] text-foreground-400">
                <i className="ri-fire-line mr-1"></i>
                {topic.heat} 热度
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}